var map = {
	"./dark_blue_fish.webp": 1604,
	"./dark_green_fish.webp": 45355,
	"./green_lime.webp": 76425,
	"./green_star.webp": 88308,
	"./orange.webp": 63662,
	"./orange_star.webp": 11547,
	"./red_apple.webp": 74488,
	"./tomato.webp": 72702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14968;